module.exports = __webpack_public_path__ + "static/media/IMG_0075.4baa3b92.jpg";